import { render, staticRenderFns } from "./BoardTemplate.vue?vue&type=template&id=0e42a006&scoped=true"
import script from "./BoardTemplate.vue?vue&type=script&lang=js"
export * from "./BoardTemplate.vue?vue&type=script&lang=js"
import style0 from "./BoardTemplate.vue?vue&type=style&index=0&id=0e42a006&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e42a006",
  null
  
)

export default component.exports